import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import ItemTabs from 'components/ItemTabs'
import ScheduleList from 'components/Lists/ScheduleList'
import Select from 'components/Inputs/Select'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container, FilterContainer, Row } from '../styles'

export default function CustomerSchedules ({ customer }) {
  const STATUS_LIST = [
    {label: 'Próximos', value: 'next'},
    {label: 'Concluídos', value: 'done'}
  ]

  const [loading, setLoading] = useState (true)
  const [page, setPage] = useState (1)
  const [lastPage, setLastPage] = useState (0)
  const [status, setStatus] = useState (STATUS_LIST[0].value)
  const [total, setTotal] = useState (0)
  const [schedules, setSchedules] = useState ([])
  const [scheduleType, setScheduleType] = useState ({
    label: 'Todos os agendamentos', value: 'all_schedules'
  })
  const token = AuthService.getToken ()
  const businessId = AuthService.getBusinessId ()
  const isProfessional = AuthService.isProfessional ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getSchedules (1)
  }, [customer, status, scheduleType])

  const getSchedules = async (pageNumber = page) => {
    if (lastPage && pageNumber > lastPage) return
    const order = status === 'next' ? 'asc' : 'desc'
    
    let filters = `&business_id=${businessId}&page=${pageNumber}`
                + `&status=${status}&per_page=25&order=${order}&canceled=all`

    if (isProfessional) filters += '&show_all_professionals=true'
    if (scheduleType.value === 'cutilei') filters += '&cutilei_schedules=true'
    else if (scheduleType.value === 'business') filters += '&cutilei_schedules=false'

    try {
      if (pageNumber === 1) setLoading (true)
      
      const { data: schedulesResponse } = await cutileiApi.get (
        `/schedules?customer_id=${customer.id}${filters}`, requestConfig
      )

      const { data, meta } = schedulesResponse

      setSchedules (pageNumber > 1 ?  [...schedules, ...data] : data)
      setPage (pageNumber + 1)
      setLastPage (meta.last_page)
      setTotal (meta.total)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  return (
    <>
      <FilterContainer>
        <Select
          name='scheduleType'
          placeholder='Tipo de agendamento...'
          value={scheduleType}
          options={[
            {label: 'Todos os agendamentos', value: 'all_schedules'},
            {label: 'Agendamentos Cutilei', value: 'cutilei'},
            {label: 'Agendamentos do salão', value: 'business'}
          ]}
          onChange={(_, option) => setScheduleType (option)}
          containerStyles={{
            width: 260,
            marginBottom: 10
          }}
        />
        <Row style={{paddingInline: 25}}>
          <ItemTabs
            tabs={STATUS_LIST}
            selectedTab={status}
            onTabChange={setStatus}
            containerStyle={{paddingTop: 0}}
          />
        </Row>
      </FilterContainer>
      <Container style={{minHeight: 120}}>
        {loading ? <Loading style={{marginBottom: 20}}/> : (
          <ScheduleList
            schedules={schedules}
            totalSchedules={total}
            hasMore={!(lastPage && page > lastPage)}
            onScroll={() => getSchedules ()}
            detailed={true}
          />
        )}
      </Container>
    </>
  )
}
